import Config from '@/../../config.json';
import SocketIO from 'socket.io-client';
import SocketIOFileUpload from 'socketio-file-upload';

const apiBasePath = require('../../lib/base-path');
const apiPort = Config.port || 3000;
const apiOrigin =
  process.env.NODE_ENV === 'development'
    ? `${window.location.protocol}//${window.location.hostname}:${apiPort}/`
    : window.location.origin;
const apiBaseUri = apiOrigin.replace(/\/$/, '') + apiBasePath;

const socket = SocketIO(apiOrigin, {
  transports: ['websocket'],
  path: `${apiBasePath}socket.io`,
});

const imgUploader = new SocketIOFileUpload(socket);

export default {
  apiBaseUri,
  socket,
  imgUploader,
};
